// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/vapor/_Checkbox.scss
// module id = 375
// module chunks = 86 87